/* eslint-disable */
export class Conf {
         /*static idempiereUrl = 'http://192.168.100.153:8090'*/

         //static idempiereUrl = 'http://nasvitech.synology.me:8090'
         //static idempiereUrl = 'http://localhost:8081/'
         static idempiereUrl = "https://idempiere.vitechsrl.it/";   //test

         //static codiceDitta = 2;//Codice ditta produzione 8    //test
         static codiceDitta = 8;
         static windowTitle = "VITECH";
       }